module.exports = "<div id=\"auhen-container\">\n  <router-outlet></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/authen/_views/authen.component.html
// module id = ./src/app/authen/_views/authen.component.html
// module chunks = main